"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrubDataByType = scrubDataByType;

var _DataScrubbersByType = require("./DataScrubbersByType");

function scrubDataByType(type, value) {
  var scrubber = _DataScrubbersByType.DataScrubbersByType[type];
  return scrubber ? scrubber(value) : value;
}